import { useStaticQuery, graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import Section from '../common/Section';
import ShapesGrape from '../icons/shapes-grape-1.svg';
import ShapesGreen from '../icons/shapes-green-5.svg';

const Error = () => {
  const data = useStaticQuery(graphql`
    {
      error: file(relativePath: { eq: "error/error.png" }) {
        childImageSharp {
          gatsbyImageData(width: 400, placeholder: NONE, layout: CONSTRAINED)
        }
      }
    }
  `);
  return (
    <StyledSection>
      <StyledShapesGrape />
      <GatsbyImage
        image={data.error.childImageSharp.gatsbyImageData}
        alt="Error"
        objectFit="contain"
      />
      <Title>Something’s not right</Title>
      <Content>
        Try visiting the <Link to="/">Homepage</Link> or check back soon.
      </Content>
      <Small>
        If you need to get in touch, please contact us at{' '}
        <a href="mailto:info@commerce7.com">info@commerce7.com</a>
        <br /> for general inquiries or{' '}
        <a href="mailto:support@commerce7.com">support@commerce7.com</a> for
        customer support.
      </Small>
      <StyledShapesGreen />
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  margin-bottom: 250px;
  margin-top: 210px;
  text-align: center;
  position: relative;
  .gatsby-image-wrapper {
    width: 200px;
    margin: 0 auto 30px;
  }
`;

const Title = styled.h1`
  color: var(--blue-dark);
  font-size: var(--heading-size-2xl);
  font-weight: var(--font-weight-black);
  margin-bottom: 15px;
`;

const Content = styled.p`
  font-size: var(--font-size-lg);

  margin-bottom: 30px;
  a {
    color: var(--blue-base);
  }
`;

const Small = styled.small`
  a {
    color: var(--blue-base);
  }
`;

const StyledShapesGrape = styled(ShapesGrape)`
  position: absolute;
  left: 0;
  top: 100px;
  z-index: -1;
`;

const StyledShapesGreen = styled(ShapesGreen)`
  position: absolute;
  right: 0;
  top: 200px;
  z-index: -1;
`;

export default Error;
